import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
const Map = lazy(() => import('@project/routes/pages/Map'));

export const MapRoutes = () => {
  return (
    <Routes>
      <Route index element={<Map />} />
    </Routes>
  );
};
